__turbopack_context__.v({
  "hiddenOnMobile": "tQM2rq_hiddenOnMobile",
  "wrapper": "tQM2rq_wrapper",
});
